import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStop = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 6,
		y: 6,
		width: 12,
		height: 12,
		rx: 2,
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgStop);
export default ForwardRef;
